<script setup lang="ts">
const route = useRoute()

const { data } = await useAsyncData(`cekaja-${route.path}`, () =>
  queryCollection('cekaja').path(route.path).first()
)

if (!data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page not found'
  })
}

const courier = computed(() =>
  getCourierProps(route.params.slug?.toString() || '')
)

useDefaultMeta({
  title: data.value.meta?.title ?? data.value.title,
  description: data.value.meta?.description ?? data.value.description,

  robots: 'index, follow',
  schema: {
    type: ['SoftwareApplication', 'WebApplication'],
    breadcrumbs: [
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Cek Resi',
        item: appUrl('/cekaja')
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: courier.value?.courier || 'Cek Resi',
        item: appUrl(route.fullPath)
      }
    ]
  }
})
</script>
<template>
  <CekajaHero
    :courier="courier"
    :priority="route.params.slug?.toString()"
    :title="data?.title"
    :description="data?.description"
  />
  <PresetBenefit
    v-if="data?.benefit"
    :benefit-title="data?.benefit.title"
    :benefits="data?.benefit.items ?? []"
  />
  <UiSectionWrapper
    image-class="order-first lg:order-first"
    :title="data?.business_cta?.title"
    :description="data?.business_cta?.description"
    :button-label="data?.business_cta?.label"
    button-link="/integration"
    hero-image="/images/batch-2/api-integration-praktis.webp"
    class="py-12"
  />
  <PresetCourier />
  <FaqBase
    v-if="data?.faq"
    :title="data?.faq.title"
    :faqs="data?.faq.items ?? []"
  />
  <CtaSection />
</template>
